var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 19 18",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffdb1f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 10 1-5.5c.2-1-1-1.6-1.7-.9l-2.9 2.8c-.4.4-1.1.4-1.4 0l-2.7-3c-.5-.4-1.1-.4-1.5-0l-2.8 3c-.4.4-1 .4-1.4 0l-2.9-2.8c-.7-.6-1.8 0-1.7.9l1 5.5.4 2.6c0 .2.2.4.4.6.7.4 2.9 1.3 7.7 1.3s7-.9 7.7-1.3c.2-.1.3-.3.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.5 15c-4.8 0-7.2-1.1-8-1.5v1.5c.7.2 3.2 1.5 8 1.5s7.3-1 8-1.5v-1.5c-.8.5-3.2 1.5-8 1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.8251bffaaadb685b7b6565e9fc4f39ff.svg";
export { ForwardRef as ReactComponent };